/*eslint no-lone-blocks: "error"*/
import React, { Suspense } from 'react';
import { Switch, RouteComponentProps } from 'react-router-dom';
import RouteWithSubRoutes from 'components/shared/RouteWithSubRoutes';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import useBreadcrumbs from 'hooks/useBreadcrumbs';
import routes from './routes';

const HomeContainer = ({ history }: RouteComponentProps) => {
  useBreadcrumbs(history, routes);
  return (
    <Suspense fallback={<LoadingSpinner />}>
      <Switch>
        {routes.map((route, i) => (
          <RouteWithSubRoutes key={`${i}_${route.path}`} {...route} />
        ))}
      </Switch>
    </Suspense>
  );
};

export default HomeContainer;
